import { AnnouncementCreateUpdateDTO, AnnouncementDTO } from "../../../../Api";
import { AnnouncementFormModel } from "../models/AnnouncementFormModel";
import dayjs from "../../../../utils/dayjs-setup";

const toDateOrUndefined = (value: unknown): Date | undefined => {
	if (value === null || value === undefined || value === "") return undefined;

	if (typeof value === "object" && value !== null && "toISOString" in value) {
		const iso = (value as { toISOString: () => string }).toISOString();
		const d = new Date(iso);
		return Number.isNaN(d.getTime()) ? undefined : d;
	}

	const parsed = dayjs(value as string | number | Date);
	if (!parsed.isValid()) return undefined;
	const d = new Date(parsed.toISOString());
	return Number.isNaN(d.getTime()) ? undefined : d;
};

export const toDomainModel = (
	model: AnnouncementFormModel,
	selectedFaculties: string[]
): AnnouncementCreateUpdateDTO => ({
	title: model.title?.trim() || null,
	description: model.description?.trim() || null,
	validFrom: toDateOrUndefined(model.validFrom),
	validTo: toDateOrUndefined(model.validTo),
	recipientRole: model.recipientRole,
	faculties: selectedFaculties?.length ? selectedFaculties : null,
	departments: model.departments?.length ? model.departments : null,
	studyPrograms: model.studyPrograms?.length ? model.studyPrograms : null,
	years: model.years?.length ? model.years : null,
	studyCycles: model.studyCycles?.length ? model.studyCycles : null,
	targetCompanyIds: model.targetCompanyIds?.length
		? model.targetCompanyIds
		: null,
});

export const toFormModel = (
	record: AnnouncementDTO
): Partial<AnnouncementFormModel> => ({
	title: record.title ?? "",
	description: record.description ?? "",
	validFrom: record.validFrom
		? (dayjs(record.validFrom) as unknown as string)
		: "",
	validTo: record.validTo ? (dayjs(record.validTo) as unknown as string) : "",
	recipientRole: record.recipientRole,
	faculties: record.faculties?.map((f) => f.id ?? "").filter(Boolean) ?? [],
	departments: record.departments?.map((d) => d.id ?? "").filter(Boolean) ?? [],
	studyPrograms:
		record.studyPrograms?.map((sp) => sp.id ?? "").filter(Boolean) ?? [],
	years: record.years ?? [],
	studyCycles: record.studyCycles ?? [],
	targetCompanyIds: record.targetCompanyIds ?? [],
});
